export default __webpack_public_path__ + "static/media/navArrow.92ac3d40.svg";